<template>
  <div class="main">
    <my-header title="公告信息" back-path="/"></my-header>
    <div class="container">
      <div class="top">
        <tab :items="['本周公告','历史公告']" @change="changeView"></tab>
      </div>
      <div class="notify">
        <div class="week" v-if="isWeek">
          <div class="item" v-for="(w,i) in getWeekNotify" :key="`week_notify_${i}`" @click="viewDetail(w)">
            <div>
              <div class="title" v-text="w.name"></div>
              <div class="time" v-text="comm.dateFormat(w.updatedAt,'yyyy年MM月dd日')"></div>
            </div>
            <div class="content" v-text="comm.htmlFormat(w.html)">
            </div>
          </div>
          <div v-if="!getWeekNotify.length" class="none">
            <span>本周暂无公告</span>
          </div>
        </div>
        <div class="history" v-else>
          <div class="item" v-for="(w,i) in getHistoryNotify" :key="`history_notify_${i}`" @click="viewDetail(w)">
            <div>
              <div class="title" v-text="w.name"></div>
              <div class="time" v-text="comm.dateFormat(w.updatedAt,'yyyy年MM月dd日')"></div>
            </div>
            <div class="content" v-text="comm.htmlFormat(w.html)">
            </div>
          </div>
          <div v-if="!getHistoryNotify.length" class="none">
            <span>暂无历史公告</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyHeader from '@/components/HeaderTitle'
import Tab from '@/components/Tab'
import comm from '@/assets/lib/comm'
import basic from '@/model/zone'
import { mapState } from 'vuex'

export default {
  name: 'Notify',
  data () {
    return {
      isWeek: true,
      comm: comm
    }
  },
  created () {
    if (!this.zone) {
      basic.getBasicInfo()
    }
  },
  computed: {
    ...mapState(['notify', 'zone']),
    getWeekNotify () {
      return this.notify.filter(n => new Date(n.updatedAt) >= comm.getDateOfStart())
    },
    getHistoryNotify () {
      return this.notify.filter(n => new Date(n.updatedAt) < comm.getDateOfStart())
    }
  },
  components: {
    MyHeader,
    Tab
  },
  mounted () {
  },
  methods: {
    changeView (i) {
      this.isWeek = (i === 0 && true) || false
    },
    viewDetail (notify) {
      this.$router.push({ name: 'notifyDetail', params: { id: notify.id, notify: notify } })
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/base";

.main {
  .container {
    margin: 65px 20px 20px 20px;
    background-color: white;
    box-shadow: 0px 3px 10px 1px rgba(56, 126, 232, 0.1);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .top {
      padding: 22px 30px 20px 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div:last-child {
        font-size: 15px;
        font-weight: 600;
        color: rgba(28, 50, 79, 1);
      }
    }
    .notify {
      flex: 1;
      padding: 10px 30px 10px 30px;
      overflow-y: auto;
      .week, .history {
        .item:first-child {
          margin-top: 0px;
        }
        .item {
          cursor: pointer;
          margin-top: 25px;
          padding-bottom: 24px;
          border-bottom: 1px solid #F5F8FA;
          > div:first-child {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .title {
            font-size: 18px;
            font-weight: 600;
            color: rgba(28, 50, 79, 1);
          }
          .time {
            font-size: 14px;
            font-weight: 400;
            color: rgba(28, 50, 79, 1);
          }
          .content {
            margin-top: 18px;
            position: relative;
            font-size: 14px;
            height: 44px;
            .auto-hide;
            white-space: normal;
            font-weight: 400;
            width: 100%;
            color: rgba(149, 166, 191, 1);
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
